import { Module, MutationTree, ActionTree, GetterTree } from "vuex";

export class alertState {
  code: string | alertCode | null = null;
  error_msg: string = "";
}
const Mutations: MutationTree<alertState> = {
  openAlert(state: alertState, payload: string | alertCode | null) {
    state.code = payload;
  },
  updateErrorMsg(state: alertState, payload: string) {
    state.error_msg = payload;
  },
};
const Actions: ActionTree<alertState, any> = {
  openAlert({ commit }, payload: string | alertCode | null) {
    commit("openAlert", payload);
  },
  updateErrorMsg({ commit }, payload: string) {
    commit("updateErrorMsg", payload);
  },
};
const Getters: GetterTree<alertState, any> = {
  getAlertState: (state: alertState) => (): string | alertCode | null => {
    return state.code;
  },
  getErrorMsg: (state: alertState) => (): string => {
    return state.error_msg;
  },
};

const module: Module<alertState, any> = {
  namespaced: true,
  state: new alertState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
